// Component based on W3Schools React tutorial: https://www.w3schools.com/react/react_components.asp
import React from 'react';
import "../css/Footer.css";

const Footer = () => {
    return (
        <footer>
            <p>2024 Oktoberfest. All rights reserved.</p>
        </footer>
    );
};

export default Footer;

